import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-dialog-background-color: var(--sds-dialog-background-color, var(--sds-color-surface-default, var(--sds-color-main-surface-default)));
		--_sds-dialog-backdrop-color: var(--sds-dialog-backdrop-color, rgba(0, 0, 0, 0.5));

		--_sds-dialog-border-color: var(--sds-dialog-border-color, var(--sds-color-border-subtle, var(--sds-color-main-border-subtle)));
		--_sds-dialog-border-radius: var(--sds-dialog-border-radius, var(--sds-radius-md));
		--_sds-dialog-border-width: var(--sds-dialog-border-width, var(--sds-border-sm));

		--_sds-dialog-max-width: var(--sds-dialog-max-width, min(60ch, 100vw));
		--_sds-dialog-max-height: var(--sds-dialog-max-height, calc(100dvh - var(--sds-spacing-lg)));

		--_sds-dialog-margin: var(--sds-dialog-margin, auto);
		--_sds-dialog-padding-block: var(--sds-dialog-padding-block, var(--sds-spacing-sm));
		--_sds-dialog-padding-inline: var(--sds-dialog-padding-inline, var(--sds-spacing-sm));
		--_sds-dialog-gap: var(--sds-dialog-gap, var(--sds-spacing-xs));

		--_sds-dialog-font-family: var(--sds-dialog-font-family, var(--sds-typography-font-family-roboto));
		--_sds-dialog-text-color: var(--sds-dialog-text-color, var(--sds-color-text-default, var(--sds-color-main-text-default)));

		--_sds-dialog-box-shadow: var(--sds-dialog-box-shadow, 0 4px 6px -1px rgba(0, 0, 0, 0.1));

		--_sds-dialog-animation-duration: var(--sds-dialog-animation-duration, 200ms);
		--_sds-dialog-close-button-offset: var(--sds-dialog-close-button-offset, var(--sds-spacing-3xs));

		display: contents;
	}

	dialog {
		color: var(--_sds-dialog-text-color);
		background-color: var(--_sds-dialog-background-color);
		box-shadow: var(--_sds-dialog-box-shadow);

		border: var(--_sds-dialog-border-width) solid var(--_sds-dialog-border-color);
		border-radius: var(--_sds-dialog-border-radius);

		font-family: var(--_sds-dialog-font-family);

		max-width: var(--_sds-dialog-max-width);
		max-height: var(--_sds-dialog-max-height);

		overflow: auto;
		padding: 0;

		opacity: 0;
		transform: translateY(-1rem);
		animation: sds-dialog-fade-in var(--_sds-dialog-animation-duration) ease-out forwards;

		&:focus-visible {
			outline: 3px solid var(--sds-color-states-focus-outer);
			outline-offset: 3px;
		}

		&[open] {
			display: flex;
			flex-direction: column;
			margin: var(--_sds-dialog-margin);
			padding-block: var(--_sds-dialog-padding-block);
			padding-inline: var(--_sds-dialog-padding-inline);
			gap: var(--_sds-dialog-gap);
		}

		&.sds-dialog__empty-header {
			/* Set gap to 0 to collapse empty header */
			--_sds-dialog-gap: var(--sds-dialog-gap, var(--sds-spacing-zero));
			/* Set padding right to avoid overflowing the close button */
			padding-right: var(--sds-dialog-padding-right, var(--sds-spacing-lg));
		}

		&::backdrop {
			background-color: var(--_sds-dialog-backdrop-color);
			/* @keyframes does not work for ::backdrop in Firefox, so use transition instead */
			transition: opacity var(--_sds-dialog-animation-duration) ease-out;
			opacity: 0;
		}

		&[open]::backdrop {
			opacity: 1;
		}
	}

	@keyframes sds-dialog-fade-in {
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.sds-dialog__close-button {
		--sds-button-text-color: var(--sds-dialog-close-button-color, var(--sds-color-text-subtle, var(--sds-color-main-text-subtle)));
		--sds-button-padding-inline: 0;

		position: absolute;
		top: var(--_sds-dialog-close-button-offset);
		right: var(--_sds-dialog-close-button-offset);
		z-index: 1;
	}

	.sds-dialog__header {
		margin-right: var(--sds-spacing-lg);
	}

	@media (max-width: 640px) {
		:host {
			--_sds-dialog-max-width: var(--sds-dialog-max-width, 100%);
			--_sds-dialog-margin: var(--sds-dialog-margin, var(--sds-spacing-xs));
		}
	}

	@media (prefers-reduced-motion: reduce) {
		:host {
			--_sds-dialog-animation-duration: 0ms;
		}
	}
`;
